import { render } from "./HeroiconsOutlineDocumentSearch.vue?vue&type=template&id=fd5cb2a4"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocumentSearch.vue"]])

export default __exports__